// @flow @jsx h
/* eslint-disable promise/catch-or-return */
/* eslint-disable promise/always-return */
/* eslint-disable compat/compat */

import { Component, h } from 'preact'
import { DisableScroll } from '../../../../lib/DisableScroll'

import styles from './index.css'

type Props = {
  viewport: { height: number },
  allowed: boolean,
  complete: boolean,
  onComplete: () => void
}

export class Logo extends Component<Props> {
  elm: HTMLElement
  animationElm: HTMLElement
  disableScroll: any
  animation: any
  animationStarted = false
  fadingOut = false

  componentDidMount () {
    this.disableScroll = new DisableScroll(this.handleScroll)
  }

  componentDidUpdate (previousProps: Props) {
    if (!previousProps.complete && this.props.complete) {
      this.fadeOut()
    } else if (this.props.complete) {
      return
    }

    if (!previousProps.allowed && this.props.allowed) {
      // this.show()
    } else if (previousProps.allowed && !this.props.allowed) {
      this.fadeOut()
    }
  }

  handleScroll = () => {
    this.fadeOut()
  }

  fadeOut = () => {
    if (this.fadingOut) {
      return
    }

    this.fadingOut = true
    this.elm.style.opacity = '0'
    setTimeout(() => {
      this.elm.style.display = 'none'
      this.props.onComplete && this.props.onComplete()

      if (this.animation) {
        this.animation.destroy()
      }

      setTimeout(() => (this.disableScroll.off()), 300)
    }, 200)
  }

  handleAnimationComplete = () => {
    setTimeout(() => {
      this.fadeOut()
    }, 2000)
  }

  render () {
    return <div
      class={styles.logo2}
      ref={elm => (this.elm = elm)} />
  }
}
